const tc = {
  signin: "登入 & 註冊",
  signout: "登出",
  home: "首頁",
  profile: "個人資料及預約",

  language: "語言",
  phone: "電話號碼",

  sms_verify_title: "驗證您的帳戶",
  sms_verify_desc: "一次性密碼已發送到你的手機號碼",

  alert_login_in: "請先登入",

  or: "或",
  continue: "繼續",
  continue_with_facebook: "使用 Facebook 繼續",
  continue_with_google: "使用 Google 繼續",

  bookings: "我的預約",
  bookings_desc: "過去的預訂記錄",
  approved: "已確認",
  pending: "處理中",
  cancelled: "已取消",

  reserve: "預約",

  profile_desc: "消費累積Flying Points，為您的下一次預訂帶來豐富的獎勵體驗。",
  profile_accumulate_hours: "累計Flying Hours",
  profile_card_point_used: "已使用Flying Points",
  profile_voucher_total: "可用優惠劵",
  profile_pending_approval: "待批核",
  profile_upload_receipt: "上傳收據",
  profile_upload_receipt_success: "成功上傳，請耐心等待批核",
  profile_upload_receipt_fail: "成功失敗",

  profile_no_more: "沒有更多紀錄",

  profile_point_his_view_title: "Flying Points紀錄",
  profile_point_his_title: "Flying Points紀錄",
  profile_voucher: "優惠劵",
  profile_point_his_id: "紀錄編號",
  profile_point_his_date: "兌換日期",
  profile_point_his_category: "類別",
  profile_point_his_quality: "數量",
  profile_point_his_remarks: "備註",

  profile_point_his_system_distribution: "系統分配",
  profile_point_his_system_promotion: "優惠推廣",
  profile_point_his_system_redeem: "Flying Points換領",

  profile_update_title: "更新個人資料",
  profile_update_title_big: "個人資訊",
  profile_update_change_image: "更換個人頭像",
  profile_update_last_name: "名稱",
  profile_update_first_name: "姓氏",
  profile_update_email: "電郵",
  profile_update_phone: "電話",
  profile_update_btn: "更新",
  profile_update_success: "更新成功",
  profile_update_missing_fields: "請填寫所有必填欄位: {{fields}}。",
  profile_accept_terms: "按下更新資料，表示您同意",

  voucher_applied: "已使用",
  voucher_available: "可用",
  voucher_available_for_all: "所有預訂",
  voucher_available_for_specific: "特定預訂",
  voucher_expired: "已過期",
  voucher_never_expire: "永不過期",

  voucher_id: "編號",
  voucher_name: "名稱及兌換碼",
  voucher_discount: "折扣",
  voucher_is_allow_free_to_apply: "適用預訂",
  voucher_expired_at: "過期日期",
  voucher_is_applied: "已使用",

  startTime: "開始時間",
  endTime: "結束時間",
  totalTime: "總時長",
  total: "總計",

  days: "天",
  minutes: "分鐘",
  hours: "小時",
  expired: "已過期",
  soon: "即將開始",
  done: "已完成",
  points: "可用Flying Points",

  showMore: "更多",
  location: "位置",
  location_desc: "毗鄰地鐵站，提供舒適便利的理想位置",
  amenities: "設施",
  amenities_desc: "關於配套和服務",
  priceAndOpening: "價格與開放時間",
  priceAndOpening_desc: "周末或節假日價格有可能調整",

  review: "查看租用時段",
  review_desc: "周末或節假日價格有可能調整",

  availability: "選擇您的租用時段",
  availability_desc: "自由選擇您的租用時段，根據您的需求提供最合適的空間體驗",

  select_start_time: "選擇開始時間",
  select_end_time: "選擇結束時間",

  rules: "使用須知",
  cancel_policy: "取消政策",
  cancel_policy_desc:
    "我們理解計劃可能會有變化，因此請詳細瞭解我們的取消政策。提前計劃是明智之舉，您可以在指定期限內取消或修改預訂。請注意，取消政策的具體條款可能會根據您的預訂類型和選擇的方案而有所不同。我們致力於提供彈性的選擇，以確保您在計劃有變化時能夠輕鬆應對。",
  venue_usage_policy: "場地守則",

  venue_usage_policy: "場地守則",
  venue_usage_policy_desc:
    "為確保每位使用者的順利體驗，請仔細閱讀並遵守我們的場地守則。這些守則旨在提供一個安全、友善、舒適的環境，請您遵從以確保每位參與者的權益和滿意度。如有任何疑問，請隨時聯絡我們的客戶服務，我們將樂意協助您。",

  checkout_title: "確認您的預約資料",
  checkout_reservation_information: "預約資訊",
  checkout_reservation_information_desc: "請覆核您你預約，一旦批核，未必能修改",
  checkout_point_redeem_badge: "是次預約將扣除",
  checkout_point_redeem_title: "使用您的Flying Points",
  checkout_point_redeem_desc: "使用帳戶內的Flying Points結算",
  checkout_point_redeem_label: "累計Flying Points",
  checkout_point_redeem_btn: "使用",
  checkout_personal_info_required: "場地預約前麻煩先填妥個人資料，謝謝:)",
  checkout_personal_info_required_btn_title: "前往填寫",

  checkout_contact_title: "聯絡資料",
  checkout_contact_email: "電郵",
  checkout_contact_phone: "電話",
  checkout_contact_remarks: "備註",
  checkout_confirm_btn: "確認預約",

  checkout_error_invalid_email: "請輸入有效電郵地址",
  checkout_error_invalid_phone: "請輸入有效電話號碼",

  price_basic_charge: "基本收費",
  price_weekly_charges: "每週收費",
  price_special_period: "特別收費時段",
  per: "每",
  everyday: "每天",
  from: "由",
  to: "至",

  footer_alert_login: "請先登入，並進行預約",
  footer_alert_select_time: "請先選擇時間，並進行預約",
  footer_login_now: "立即登入",

  pay_done_pending_title: "預約待確認",
  pay_done_success_title: "成功預約",
  pay_done_booking_id: "預約編號",
  pay_done_payment_method: "付款方式",
  payment_method_fps: "轉數快",
  payment_method_bank_transfer: "銀行轉帳",
  payment_alert: "請於預約後 6 小時內完成轉帳，並於「個人資料及預約」上傳轉帳的螢幕截圖，否則您的預約將會被自動取消，敬請留意。",
  payment_goto_my_profile: "前往上傳",
  pay_done_approved: "你可以於「個人資料及預約」查看你的預約狀態",
  pay_done_pending_admin_action: "已成功上傳，請等待確認",
  pay_done_upload_payment_title: "請盡快上傳付款證明，以便我們處理您的預約。",
  pay_done_upload_payment_desc: "假若未能在今天或使用場地時間前完成付款及上傳證明，預約將被取消。如有任何疑問，請與我們聯絡。",

  copied: "已複製到剪貼簿",

  quick_selection: "快捷查看",
  quick_selection_desc: "剩餘空位",
  selection_unit: "節",

  "app:timeslot_occupied": "所選的時段包括已預留或關閉時段",
  app_timeslot_occupied: "所選的時段包括已預留或關閉時段",
  app_end_date_time_should_not_same_or_before_start_date_time: "請選擇有效時間",

  invalid_start_time: "開始時間不能於完結時間後",
  invalid_end_time: "完結時間不能於開始時間前",

  booking_time_too_long: "預約時間不能多於",
  booking_time_too_short: "預約時間不能少於",

  confirm: "確認",

  checkout_checkbox_desc: "我已閱讀及同意",
  checkout_checkbox_error: "請先閱讀及同意",
  terms: "使用條款",
  and: "及",
  disclaimer: "免責聲明",
  personal_data_collection: "個人資料收集聲明",
  all_terms: "所有條款及免責聲明",

  packages: "優惠組合",
  packages_home_desc: "選擇您的優惠組合，享受更多優惠",
  packages_period_title_1: "此組合於",
  packages_period_title_2: "生效",
  packages_items: "組合內容包括",
  packages_purchase: "馬上訂購",
  packages_cancel: "取消訂購",
  packages_upload_proof: "上傳付款證明",
  packages_proof_uploaded: "已上傳，請耐心等待批核",

  cancellation_or_no_show_title: "取消或缺席政策",
  cancellation_or_no_show_1:
    "任何單次預約或組合優惠券僅適用於購買時指定的期限內。請注意，所有組合優惠券自首次預約開始計算，有效期為兩個月。您可以在預約時間至少48小時前作出更改。任何在有效日期內未使用的優惠券將自動失效。",
  cancellation_or_no_show_2: "如在預約時間前兩小時內發出八號或以上颱風信號，或紅色/黑色暴雨警告信號，則可重新安排預約，但不提供退款。",
  cancellation_or_no_show_3: "如果您改變主意或因任何原因無法使用預約，我們恕不提供退款。",

  personal_data_collection_title: "個人資料收集聲明",
  personal_data_collection_main: "Flying Lab承諾保障閣下的個人資料，並確保遵守香港法例第486章《個人資料（私隱）條例》。閣下提供個人資料，即表示閣下知悉並同意以下各項：",
  personal_data_collection_1_start: "1.	收集資料的目的： 您的個人資料將被收集用於以下目的： ",
  personal_data_collection_1a: "當您訪問我們的網站或 Instagram 頁面時",
  personal_data_collection_1b: "與我們互動並使用我們的場所和服務時 ",
  personal_data_collection_1_end: "我們會在本地或海外（包括雲端）安全地儲存您的資料，並負責保護您的資料安全，以符合香港法律。",
  personal_data_collection_2: "2.	資料處理： 我們將根據我們的隱私權政策處理您的個人資料，該政策概述了我們如何收集、使用和保護您的個人資料。",
  personal_data_collection_3:
    "3.	直接促銷： 這是指我們使用您的資料，向您發送我們或我們的合作品牌、獎勵或忠誠計劃合作夥伴或慈善機構所提供的場地、服務和優惠的詳細資料。在向您行銷時，我們可能會使用您的人口統計和預訂行為等資料。",
  personal_data_collection_4: "4.	資料保留： 您個人資料的保留期限僅限於達成收集目的所需的時間，或法律規定的時間。",
  personal_data_collection_5: "5.	不與第三方分享： 我們不會將您的資料提供給其他人，讓他們向您推銷他們的產品和服務。如果我們想這樣做，我們會得到您的單獨同意，或除非法律要求。",
  personal_data_collection_6: "6.	資料存取與更正： 根據《個人資料（私隱）條例》，您有權要求查閱和更正您的個人資料。如果您希望這樣做，請直接在網站上修改或在 Instagram 上聯繫我們。",
  personal_data_collection_7: "7.	撤銷同意： 您可以隨時撤回對我們使用您個人資料的同意。但請注意，這將影響我們向您提供服務的能力。",
  personal_data_collection_footer: "如果您繼續與 Flying Lab 合作並向我們進行預訂，即表示您同意我們按照本免責聲明所述收集和使用您的個人資料。",
  personal_data_collection_thanks: "感謝您的信任。",

  disclaimer_title: "免責聲明",
  disclaimer_1: "進入 Flying Lab (FL) 即表示您同意 FL 對於在練習期間或參加者位於或接近工作室時所造成的任何受傷或損失不承擔任何責任。",
  disclaimer_2:
    "您有責任確保自己在使用任何設備時，身體和醫療狀況適合相關活動。在任何時候，您都必須注意自身的安全。如果您有任何已有的健康狀況或對自己的適合度有疑問，我們建議您諮詢醫生以獲得醫療許可。",
  disclaimer_3: "在練習期間，您必須自行妥善保管個人物品，FL 對任何遺失或被盜的財物概不負責。",
  disclaimer_4: "您了解使用鋼管或任何空中設備可能需要較大的身體強度，並自願參與，充分了解其中存在人身傷害、財物損失或死亡的風險。",
  disclaimer_5: "您同意不會對 Flying Lab 或其業主提起任何形式的訴訟或索賠，無論是因人身傷害、財物損失或錯誤死亡，無論是否由疏忽造成。",
  disclaimer_6: "您承認並接受 FL 設有 24 小時錄影監控。所有錄影資料均屬 FL 的唯一財產。如因您造成任何財物或設備損壞，FL 可追究並索取賠償。",
  disclaimer_7: "您同意在任何練習前或練習期間，不飲酒或服用法律禁止的藥物。",
};

export default tc;
